import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { AuthorizedRole } from 'src/openapi-gen/models';
import { AuthService } from './auth.service';
import { NavRoutes } from '../core/constants/nav.routes';
import { ErrorRouter } from '../shared/services/error-router';

export const authGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> =>
{
    const AUTH_SERVICE = inject(AuthService);
    const ROUTER = inject(Router);
    const ERROR_ROUTER = inject(ErrorRouter);

    // Everytime a user navigates to a new componenet refresh their information.
    await AUTH_SERVICE.refreshUserInformation();

    if(!AuthService.DoTokenExpiriesExist()) {
        ROUTER.navigate([NavRoutes.Root]);
        return false;
    }

    if(!AUTH_SERVICE.isUserAuthenticated()) {
        AuthService.SetUserLoggedOut();
        ERROR_ROUTER.navigateToUnauthorized();
        return false;
    }

    let authorizedRoles = route.data.authorizedRoles as AuthorizedRole[];
    if (AUTH_SERVICE.doesUserHaveRole(authorizedRoles)) {
        return true;
    }
    else {
        AuthService.SetUserLoggedOut();
        ERROR_ROUTER.navigateToUnauthorized();
        return false;
    }
}